require('./cdnUrlFilter');

'use strict';

angular.module('app.cdnUrl', [
    'app.cdnUrl.cdnUrlFilter'
])
    .value('cdnUrl', {
        0: 'https://ddde457d3b16a8614480-1c5b19b429ddb017fc420c330826ace8.ssl.cf2.rackcdn.com',
        1: 'https://89c7411cb39bfc3efca4-508d46d50606e2835a5b5ad46a3dc2a0.ssl.cf1.rackcdn.com',
        2: 'https://assets.leaguestat.com'
    });



// WEBPACK FOOTER //
// ./app.v2/components/fhApp/cdnUrl/cdnUrl.js